module.exports = __webpack_public_path__ + "static/media/logo.bd529b83.svg";